<template>
  <div class="dea-checkbox dea-checkbox--square" :class="classType">
    <input
      :id="id"
      :type="type"
      :name="name"
      :checked="checked"
      :value="value"
      :disabled="disabled"
      v-on="$listeners"
    />
    <label class="dea-checkbox__label-wrapper" :for="id">
      <span class="dea-checkbox__label">
        <slot />
      </span>
    </label>
  </div>
</template>

<script>
/**
 *
 */
export default {
  name: "Checkbox",
  props: {
    checked: Boolean,
    type: {
      type: String,
      default: "checkbox",
    },
    id: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classType() {
      if (this.type === "checkbox") {
        return "dea-checkbox--square";
      }
      return "dea-checkbox--rounded";
    },
  },
};
</script>
